module.exports = __webpack_public_path__ + "c6c09dc6c89a231c8ebdc6534ecac1cd.png";